import React from 'react'
import {useContext} from 'react'
import {HeroContext} from './App'
export default function BatmanItem(props) {
    const {handleUpdateGoods}=useContext(HeroContext)
    const {item,value}=props
    return (
        <div>
            <p>
                Batman {item} 
                <button
                onClick={()=>{
                    handleUpdateGoods('batman',{[item]:Number([value])-1})
                }}
                >
                    -
                </button>
                <span> {value}</span>
                <button
                onClick={()=>{
                    handleUpdateGoods('batman',{[item]:Number([value])+1})
                }}
                >
                     +
                </button>
            </p>  
        </div>
    )
}
